import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router'
import { useSessionStore } from '../stores/session'

declare module 'vue-router' {
  interface RouteMeta {
    public?: boolean
    title?: string
    hideNav?: boolean
  }
}

const routes: RouteRecordRaw[] = [
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/LoginView.vue'),
    meta: { public: true, title: 'Anmelden', hideNav: true },
  },
  {
    path: '/onboarding',
    name: 'onboarding',
    component: () => import('../views/OnboardingView.vue'),
    meta: { title: 'Erste Schritte', hideNav: true },
  },
  { path: '/', name: 'dashboard', component: () => import('../views/DashboardView.vue'), meta: { title: 'Start' } },
  { path: '/scan', name: 'scan', component: () => import('../views/ScanView.vue'), meta: { title: 'Dokument scannen' } },
  {
    path: '/journeys/:id/review',
    name: 'review',
    component: () => import('../views/ReviewView.vue'),
    meta: { title: 'Reise prüfen' },
  },
  {
    path: '/journeys/:id',
    name: 'journey',
    component: () => import('../views/JourneyView.vue'),
    meta: { title: 'Reise' },
  },
  {
    path: '/devices',
    name: 'devices',
    component: () => import('../views/DevicesView.vue'),
    meta: { title: 'Standortgerät' },
  },
  {
    path: '/train',
    name: 'train',
    component: () => import('../views/TrainView.vue'),
    meta: { title: 'Zug verfolgen' },
  },
  {
    path: '/map',
    name: 'map',
    component: () => import('../views/MapView.vue'),
    meta: { title: 'Karte' },
  },
  {
    path: '/settings',
    name: 'settings',
    component: () => import('../views/SettingsView.vue'),
    meta: { title: 'Einstellungen' },
  },
  { path: '/:pathMatch(.*)*', redirect: '/' },
]

export const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior: () => ({ top: 0 }),
})

router.beforeEach(async (to) => {
  const session = useSessionStore()
  if (!session.checked) await session.fetchMe()

  if (!session.isAuthenticated) {
    return to.meta.public === true ? true : { name: 'login', query: to.fullPath === '/' ? {} : { next: to.fullPath } }
  }

  if (to.name === 'login') return { name: 'dashboard' }
  if (!session.onboardingDone && to.name !== 'onboarding') return { name: 'onboarding' }
  return true
})

router.afterEach((to) => {
  document.title = to.meta.title ? `${to.meta.title} · Reisepilot` : 'Reisepilot'
})
